import { Quote } from "lucide-react";
import "./Reviews.css";

const REVIEWS = [
    {
        text: "Раньше на разбор заявок уходил весь день. Сейчас система сама распределяет задачи — я только контролирую итог. Освободилось время на реальное управление домом.",
        name: "Марина Соколова",
        role: "Директор УК «Комфорт»",
        initials: "МС",
    },
    {
        text: "Жильцы перестали звонить по любому поводу. Теперь всё через приложение — заявка, статус, ответ. Отношения с людьми стали намного спокойнее.",
        name: "Алексей Громов",
        role: "Управляющий ЖК «Речной»",
        initials: "АГ",
    },
    {
        text: "Оплата ЖКХ прямо с телефона и без комиссии — для меня это главное. Плюс вижу все квитанции в одном месте. Пользуюсь каждый месяц.",
        name: "Елена Васильева",
        role: "Жилец, кв. 47",
        initials: "ЕВ",
    },
];

export default function Reviews() {
    return (
        <section className="possibilities-reviews" data-reveal>
            <div className="possibilities-reviews__header">
                <p className="possibilities-reviews__label">Отзывы</p>
                <h2 className="possibilities-reviews__title">Что говорят пользователи</h2>
            </div>

            <div className="possibilities-reviews__grid">
                {REVIEWS.map((review, index) => (
                    <div key={index} className="review-card">
                        <Quote
                            className="review-card__quote-icon"
                            size={28}
                            strokeWidth={1}
                        />
                        <p className="review-card__text">{review.text}</p>
                        <div className="review-card__author">
                            <div className="review-card__avatar">
                                {review.initials}
                            </div>
                            <div className="review-card__author-info">
                                <p className="review-card__name">{review.name}</p>
                                <p className="review-card__role">{review.role}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}